<script setup lang="ts">
  import { LiveChatMessage } from "~/entities/LiveChatMessage";
  interface Props {
    message: LiveChatMessage;
    loading: boolean;
  }
  const props = defineProps<Props>();

  const uesrProfileModal = ref(null);

  const clickUserIcon = () => {
    uesrProfileModal.value?.openModal(props.message.userId);
  };
</script>

<template>
  <template v-if="message.type === 'message'">
    <div class="pb-1">
      <v-sheet
        class="rounded-xl text-left d-flex justify-start py-2 pl-3 pr-4 mx-2 my-2"
        color="monochrome-06"
        style="width: fit-content"
      >
        <v-sheet class="d-flex align-center" color="transparent" :max-width="30">
          <AtomsImgWithLoading
            class="rounded-circle"
            :src="message.userImage"
            :width="30"
            :height="30"
            @click="clickUserIcon"
          />
        </v-sheet>
        <v-sheet class="text-left ml-2" color="transparent">
          <div class="text-chat-username text-text-gray">
            {{ message.userName }}
          </div>
          <div class="text-chat-message text-white">
            <AtomsAutoLink :text="message.text ?? ''" />
          </div>
        </v-sheet>
      </v-sheet>
    </div>
  </template>
  <template v-else>
    <v-sheet class="text-left d-flex px-4 py-1" color="transparent">
      <AtomsImgWithLoading
        class="mr-2 rounded-circle"
        :src="message.userImage"
        :width="20"
        :max-width="20"
        :height="20"
        @click="clickUserIcon"
      />
      <span class="text-chat-access text-text-gray">
        {{ message.text }}
      </span>
    </v-sheet>
  </template>

  <!-- プロフィールモーダル用処理 -->
  <AtomsUserProfileModal ref="uesrProfileModal" />
</template>

<style lang="scss" scoped>
  .text-chat-username {
    font-size: 10px;
    font-weight: 400;
    line-height: 12px; // 個別指定。ユーザー名のみ小さくする
    letter-spacing: 0.06em;
    text-transform: none !important;
  }
  .text-chat-message {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px; // 個別指定。チャットメッセージ
    letter-spacing: 0.06em;
    text-transform: none !important;
    white-space: break-spaces;
    word-break: break-all;
  }

  .text-chat-access {
    font-size: 12px;
    font-weight: 400;
    line-height: 1.8em;
    letter-spacing: 0.06em;
    text-transform: none !important;
  }
</style>
